"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApPersonnelThirdPartyWidget = void 0;
var React = require("react");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetBullet_1 = require("../ApWidgetBullet");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetChangeOverTime_1 = require("../ApWidgetChangeOverTime");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetName_1 = require("../ApWidgetName");
var ApWidgetValueType1_1 = require("../ApWidgetValueType1");
var styles_1 = require("./styles");
exports.ApPersonnelThirdPartyWidget = function (_a) {
    var _b = _a.config, config = _b === void 0 ? { name: '' } : _b, data = _a.data, dataError = _a.dataError, iconType = _a.iconType, props = __rest(_a, ["config", "data", "dataError", "iconType"]);
    return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
        React.createElement(styles_1.Container, null,
            data && data.nameLeft && data.nameRight
                ? (React.createElement(styles_1.BodyWrapper, null,
                    React.createElement(ApWidgetName_1.ApWidgetName, { name: data.nameLeft, iconType: config.iconType }),
                    React.createElement(ApWidgetName_1.ApWidgetName, { name: data.nameRight })))
                : null,
            dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : (!data || !data.values) ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : (React.createElement(styles_1.BodyWrapper, null,
                React.createElement(styles_1.LeftContentWrapper, null,
                    React.createElement(styles_1.TopContainer, null,
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: data.values.left.currentPeriod, value: React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, null, data.values.left.currentValue) }),
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: data.values.left.previousPeriod, value: data.values.left.previousValue })),
                    React.createElement(styles_1.AverageContainer, null,
                        React.createElement(ApWidgetChangeOverTime_1.ApWidgetChangeOverTime, { value: data.values.left.netChange, trend: 1, isNoCriteria: true, label: "Net change" }),
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: "Variance", value: data.values.left.variance }))),
                React.createElement(styles_1.LeftContentWrapper, null,
                    React.createElement(styles_1.TopContainer, null,
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: data.values.right.currentPeriod, value: React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, null, data.values.right.currentValue) }),
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: data.values.right.previousPeriod, value: data.values.right.previousValue })),
                    React.createElement(styles_1.AverageContainer, null,
                        React.createElement(ApWidgetChangeOverTime_1.ApWidgetChangeOverTime, { value: data.values.right.netChange, trend: 1, isNoCriteria: true, label: "Net change" }),
                        React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, { label: "Variance", value: data.values.right.variance }))))),
            data && data.tags && data.tags.length !== 0 && (React.createElement(ApWidgetBullet_1.ApWidgetBulletList, { list: data.tags })))));
};
exports.ApPersonnelThirdPartyWidget.defaultProps = {
    data: {
        nameLeft: 'Left',
        nameRight: 'Right',
        values: undefined,
        tags: [],
    },
};
//# sourceMappingURL=ApPersonnelThirdPartyWidget.js.map